/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTriggeredActionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'
import {GetTriggeredActionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'


export const getTriggeredActions = (request: GetTriggeredActionsRequest, options?: CashRequestOptions) => post<GetTriggeredActionsRequest, GetTriggeredActionsResponse>("/cash-app/goose-cash/v3/get-triggered-actions", request, {...options, rejectOnError: true })